/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  InviteMemberDto,
  InviteMemberResultDto,
  JoinRequestDecisionDto,
  JoinRequestDecisionResultDto,
  JoinRequestDto,
  RemoveMemberResultDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * admin sees every pending request; coop_admin sees requests for cooperatives where they are admin_user_id. Oldest-first.
 * @summary List pending join-requests for the caller's cooperative(s)
 */
export const cooperativesControllerListJoinRequests = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<JoinRequestDto[]>(
      {url: `/coop/join-requests`, method: 'GET', signal
    },
      );
    }
  



export const getCooperativesControllerListJoinRequestsQueryKey = () => {
    return [
    `/coop/join-requests`
    ] as const;
    }

    
export const getCooperativesControllerListJoinRequestsQueryOptions = <TData = Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCooperativesControllerListJoinRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>> = ({ signal }) => cooperativesControllerListJoinRequests(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CooperativesControllerListJoinRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>>
export type CooperativesControllerListJoinRequestsQueryError = unknown


export function useCooperativesControllerListJoinRequests<TData = Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCooperativesControllerListJoinRequests<TData = Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCooperativesControllerListJoinRequests<TData = Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List pending join-requests for the caller's cooperative(s)
 */

export function useCooperativesControllerListJoinRequests<TData = Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cooperativesControllerListJoinRequests>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCooperativesControllerListJoinRequestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * approve links the farmer's profile to the cooperative (principal_type='formal_coop'); reject leaves the profile untouched. 404 if the request isn't in the caller's coop; 400 if it's not pending.
 * @summary Approve or reject a pending join-request
 */
export const cooperativesControllerDecideJoinRequest = (
    id: string,
    joinRequestDecisionDto: JoinRequestDecisionDto,
 ) => {
      
      
      return fseAxios<JoinRequestDecisionResultDto>(
      {url: `/coop/join-requests/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: joinRequestDecisionDto
    },
      );
    }
  


export const getCooperativesControllerDecideJoinRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerDecideJoinRequest>>, TError,{id: string;data: JoinRequestDecisionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerDecideJoinRequest>>, TError,{id: string;data: JoinRequestDecisionDto}, TContext> => {

const mutationKey = ['cooperativesControllerDecideJoinRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cooperativesControllerDecideJoinRequest>>, {id: string;data: JoinRequestDecisionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  cooperativesControllerDecideJoinRequest(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CooperativesControllerDecideJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cooperativesControllerDecideJoinRequest>>>
    export type CooperativesControllerDecideJoinRequestMutationBody = JoinRequestDecisionDto
    export type CooperativesControllerDecideJoinRequestMutationError = unknown

    /**
 * @summary Approve or reject a pending join-request
 */
export const useCooperativesControllerDecideJoinRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerDecideJoinRequest>>, TError,{id: string;data: JoinRequestDecisionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cooperativesControllerDecideJoinRequest>>,
        TError,
        {id: string;data: JoinRequestDecisionDto},
        TContext
      > => {

      const mutationOptions = getCooperativesControllerDecideJoinRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Creates a claimable user (pin_hash NULL → /auth/claim) + a minimal farmer_profile linked to the cooperative derived from cooperatives.admin_user_id = caller. 400 if the caller admins 0 or >1 cooperatives; 409 if a user with this phone already exists.
 * @summary Invite a farmer by phone into the caller's cooperative
 */
export const cooperativesControllerInviteMember = (
    inviteMemberDto: InviteMemberDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<InviteMemberResultDto>(
      {url: `/coop/members/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteMemberDto, signal
    },
      );
    }
  


export const getCooperativesControllerInviteMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerInviteMember>>, TError,{data: InviteMemberDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerInviteMember>>, TError,{data: InviteMemberDto}, TContext> => {

const mutationKey = ['cooperativesControllerInviteMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cooperativesControllerInviteMember>>, {data: InviteMemberDto}> = (props) => {
          const {data} = props ?? {};

          return  cooperativesControllerInviteMember(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CooperativesControllerInviteMemberMutationResult = NonNullable<Awaited<ReturnType<typeof cooperativesControllerInviteMember>>>
    export type CooperativesControllerInviteMemberMutationBody = InviteMemberDto
    export type CooperativesControllerInviteMemberMutationError = unknown

    /**
 * @summary Invite a farmer by phone into the caller's cooperative
 */
export const useCooperativesControllerInviteMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerInviteMember>>, TError,{data: InviteMemberDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cooperativesControllerInviteMember>>,
        TError,
        {data: InviteMemberDto},
        TContext
      > => {

      const mutationOptions = getCooperativesControllerInviteMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Un-links the farmer_profile back to independent (G1): cooperative_id NULL, principal_type='individual'. 404 if the target isn't a member of one of the caller's cooperatives.
 * @summary Remove a member from the caller's cooperative
 */
export const cooperativesControllerRemoveMember = (
    userId: string,
 ) => {
      
      
      return fseAxios<RemoveMemberResultDto>(
      {url: `/coop/members/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getCooperativesControllerRemoveMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerRemoveMember>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerRemoveMember>>, TError,{userId: string}, TContext> => {

const mutationKey = ['cooperativesControllerRemoveMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cooperativesControllerRemoveMember>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  cooperativesControllerRemoveMember(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CooperativesControllerRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof cooperativesControllerRemoveMember>>>
    
    export type CooperativesControllerRemoveMemberMutationError = unknown

    /**
 * @summary Remove a member from the caller's cooperative
 */
export const useCooperativesControllerRemoveMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cooperativesControllerRemoveMember>>, TError,{userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cooperativesControllerRemoveMember>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getCooperativesControllerRemoveMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    